/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Seo_TitleInputs */

const en_nfp_seo_title = /** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC for Non-Profits | The Modern Community Hub`)
};

const es_nfp_seo_title = /** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC para ONGs | El Centro Comunitario Moderno`)
};

const fr_nfp_seo_title = /** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC pour les associations | Le Hub Communautaire Moderne`)
};

const de_nfp_seo_title = /** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC für NGOs | Der moderne Community-Hub`)
};

const id_nfp_seo_title = /** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC untuk Non-Profit | Hub Komunitas Modern`)
};

/** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */
const ja_nfp_seo_title = en_nfp_seo_title;

/** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */
const zh_nfp_seo_title = en_nfp_seo_title;

/** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */
const ar_nfp_seo_title = en_nfp_seo_title;

/** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */
const it_nfp_seo_title = en_nfp_seo_title;

/** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */
const ru_nfp_seo_title = en_nfp_seo_title;

/** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */
const pt_nfp_seo_title = en_nfp_seo_title;

/** @type {(inputs: Nfp_Seo_TitleInputs) => LocalizedString} */
const ko_nfp_seo_title = en_nfp_seo_title;

/**
* | output |
* | --- |
* | "SSC for Non-Profits \| The Modern Community Hub" |
*
* @param {Nfp_Seo_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_seo_title = /** @type {((inputs?: Nfp_Seo_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Seo_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_seo_title(inputs)
	if (locale === "es") return es_nfp_seo_title(inputs)
	if (locale === "fr") return fr_nfp_seo_title(inputs)
	if (locale === "de") return de_nfp_seo_title(inputs)
	if (locale === "ja") return ja_nfp_seo_title(inputs)
	if (locale === "zh") return zh_nfp_seo_title(inputs)
	if (locale === "ar") return ar_nfp_seo_title(inputs)
	if (locale === "id") return id_nfp_seo_title(inputs)
	if (locale === "it") return it_nfp_seo_title(inputs)
	if (locale === "ru") return ru_nfp_seo_title(inputs)
	if (locale === "pt") return pt_nfp_seo_title(inputs)
	return ko_nfp_seo_title(inputs)
});